import { useCallback } from "react";
import { fetchData } from "../utils/api";
import { baseUrl } from "../utils/strings";

const useItuData = ({
  indicator,
  existingData,
  countryName,
  newCountryName,
  existingLegends,
  layerLevelPerCountry,
  setLoading,
  setMessage,
  setExistingData,
  setExistingLegends,
}) => {
  const ituLegendData = existingLegends?.find((legend) => {
    return legend?.name === `${newCountryName}-${layerLevelPerCountry}`;
  });

  const ituLegends = ituLegendData?.data;

  const getUrl = (keyword, layerLevel) => {
    return `${baseUrl}/api/${keyword}?country_name=${newCountryName}&layer_level=${layerLevel}`
  }

  const getItuLegends = useCallback(
    async (layerLevel) => {
      const isLegendExist = existingLegends.find((data) => data.name === `${newCountryName}-${layerLevel}`);

      if (!isLegendExist) {
        const data = await fetchData(getUrl("itu_legends", layerLevel), setMessage);

        setExistingLegends([
          ...existingLegends,
          { name: `${newCountryName}-${layerLevel}`, data },
        ]);
      }

      return null;
    },
    // eslint-disable-next-line
    [existingLegends, newCountryName, setExistingLegends, setMessage]
  );

  const getITUData = useCallback(async (layerLevel) => {
      setLoading([indicator]);

      const isDataExist = existingData.find(
        (data) => data.dataName === `${newCountryName}-${layerLevel}`
      );

      if (!isDataExist) {
        const data = await fetchData(getUrl("itu_data", layerLevel), setMessage);

        setExistingData([
          ...existingData,
          {
            data,
            layerLevel: layerLevel,
            country: countryName,
            dataName: `${newCountryName}-${layerLevel}`,
          },
        ]);
      }

      setLoading([]);
      return null;
    },
    // eslint-disable-next-line
    [indicator,  existingData, countryName, newCountryName, setExistingLegends, setLoading]
  );

  return { ituLegendData, ituLegends, getItuLegends, getITUData };
};

export default useItuData;